import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService, IDP_APPS } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertAdvisoriesComponent } from '../../common/alert-advisories/alert-advisories.component';
import { CookieHelper } from '../../common/cookie-helper';
import { CountryLanguageHelper } from '../../common/country-language-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { FlyoutLangSelectConfirmationComponent } from '../../flyout/flyout-lang-select-confirmation/flyout-lang-select-confirmation.component';
import { ContentCountryLanguage } from '../../model/content/contentCountryLanguage.model';
import { CommonEndpointKeys } from '../../model/enums/common.enums';
import { ClosestAirPortcode } from '../closestairportcode.service';
import { CommonService } from '../common.service';
import { CountryLanguageService } from '../country_Language/country_Language.service';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class TranslatedsitesLangService {
  prefCookieValue: string;
  private disableCLS = true;
  closestAirportCodeSubsriber: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  config = {
    animated: false
  };

  alertflag = false;
  bsModalRef: BsModalRef;
  bsModalConfirmationRef: BsModalRef;
  countryLanguageContent: ContentCountryLanguage;
  modalOnHiddenSubscription: Subscription;
  alertAdvComp: AlertAdvisoriesComponent;
  public _appliSubject = new BehaviorSubject(false);
  public opencls = new BehaviorSubject(false);
  prop: string;
  constructor(
    private appConfig: ApplicationConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cookieHelper: CookieHelper,
    private countryLanguageHelper: CountryLanguageHelper,
    private countryLangSvc: CountryLanguageService,
    private srv: CommonService,
    private modalService: BsModalService,
    private closestAirportCode: ClosestAirPortcode,
    private route: ActivatedRoute,
    private datalayer: DataLayer,
    private appConfigService: AppConfigService
  ) {}

  detectCurrentLanguage(el?, renderer?) {
    if (isPlatformBrowser(this.platformId)) {
      this.disableCLS =
        this.appConfig.get('APP_DISABLE_CLS2') &&
        this.appConfig.get('APP_DISABLE_CLS2') === 'true'
          ? true
          : false;
    }
    const defaultCountry = this.appConfig.get('APP_DEFAULT_COUNTRY');
    const defaultBrowserLanguage = this.appConfig.get(
      'APP_DEFAULT_BROWSER_LANG'
    );
    this.prefCookieValue = this.cookieHelper.getCookies('prefUI');
    const countryCode = this.cookieHelper.getCountryCode();
    if (!countryCode || countryCode === '') {
      if (!this.disableCLS) {
        this.closestAirportCodeSubsriber = this.closestAirportCode
          .getClosestDeltaAirportCode()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data && data['countrycode']) {
                this.datalayer.setClosestDeltaAirportCode(data?.airportcode);
                this.countryLangSvc
                  .countryLanguageDataFromAPI()
                  .pipe(takeUntil(this.unsubscribe))
                  .subscribe((countryLanguageData) => {
                    this.countryLanguageHelper.setData(countryLanguageData);
                    const countrycode = data['countrycode'].toLowerCase();
                    const primaryLanguage =
                      this.countryLanguageHelper.getPrimaryLanguage(
                        countrycode
                      );
                    const browserLanguage =
                      this.countryLanguageHelper.detectBrowserLanguage();
                    // Check if language selection modal is enabled via feature flag
                    this.appConfigService
                      .getConfigValue(
                        IDP_APPS.COMMON,
                        CommonEndpointKeys['ENABLE_LANGUAGE_SELECTION_MODAL']
                      )
                      .subscribe((enableLanguageSelectionModal: string) => {
                        if (
                          this.countryLanguageHelper.isLanguageSupportedByCountry(
                            countrycode,
                            browserLanguage
                          )
                        ) {
                          this.countryLanguageHelper.setPrefCookie(
                            browserLanguage + '-' + countrycode
                          );
                          if (
                            countrycode === defaultCountry &&
                            browserLanguage === defaultBrowserLanguage
                          ) {
                            this.countryLanguageHelper.setShowConfirmationModal(
                              false
                            );
                            this.countryLanguageHelper.setPreferedLanguages(
                              this.appConfig.get('APP_PREF_COOKIE')
                            );
                            if (this.propertyCheck()) {
                              this._appliSubject.next(true);
                            }
                            if (
                              !this.countryLanguageHelper.isDomainCorrectForPrefCookie()
                            ) {
                              this.countryLanguageHelper.setShowConfirmationModal(
                                true
                              );
                              this.countryLanguageHelper.redirectToTranslatedSites(
                                this.countryLanguageHelper.getCountryCodeFromPrefCookie(),
                                this.countryLanguageHelper.getLanguageCodeFromPrefCookie()
                              );
                            }
                          } else {
                            this.countryLanguageHelper.setShowConfirmationModal(
                              true
                            );
                            if (enableLanguageSelectionModal == 'true') {
                              // Feature flag is ON - skip redirectToTranslatedSites
                              if (
                                this.countryLanguageHelper.getSecondaryLanguage(
                                  countrycode
                                )
                              ) {
                                this.openLangSelectConfirmationModal(
                                  countrycode,
                                  browserLanguage,
                                  primaryLanguage.languageCode,
                                  el,
                                  renderer
                                );
                              } else {
                                this.countryLanguageHelper.loadSelectedLanguage(
                                  countrycode,
                                  primaryLanguage.languageCode,
                                  enableLanguageSelectionModal
                                );
                              }
                            } else {
                              // Feature flag is OFF - use redirectToTranslatedSites
                              this.countryLanguageHelper.redirectToTranslatedSites(
                                countrycode,
                                browserLanguage
                              );
                            }
                          }
                        } else {
                          if (primaryLanguage) {
                            this.countryLanguageHelper.setPrefCookie(
                              primaryLanguage.languageCode + '-' + countrycode
                            );
                            this.countryLanguageHelper.setPreferedLanguages(
                              primaryLanguage.languageCode + '-' + countrycode
                            );
                            const secondaryLanguage =
                              this.countryLanguageHelper.getSecondaryLanguage(
                                countrycode
                              );
                            if (
                              !this.countryLanguageHelper.isDomainCorrectForPrefCookie()
                            ) {
                              if (secondaryLanguage) {
                                this.countryLanguageHelper.setShowConfirmationModal(
                                  true
                                );
                              }
                              if (enableLanguageSelectionModal === 'true') {
                                this.countryLanguageHelper.loadSelectedLanguage(
                                  countrycode,
                                  primaryLanguage.languageCode,
                                  enableLanguageSelectionModal
                                );
                              } else {
                                this.countryLanguageHelper.redirectToTranslatedSites(
                                  this.countryLanguageHelper.getCountryCodeFromPrefCookie(),
                                  this.countryLanguageHelper.getLanguageCodeFromPrefCookie()
                                );
                              }
                            } else {
                              if (
                                secondaryLanguage &&
                                enableLanguageSelectionModal === 'true'
                              ) {
                                this.openLangSelectConfirmationModal(
                                  countrycode,
                                  primaryLanguage.languageCode,
                                  secondaryLanguage.languageCode,
                                  el,
                                  renderer
                                );
                              } else {
                                this.openLangSelectConfirmationModal(
                                  countrycode,
                                  primaryLanguage.languageCode,
                                  secondaryLanguage.languageCode
                                );
                              }
                            }
                          }
                          if (this.propertyCheck()) {
                            this._appliSubject.next(true);
                          }
                        }
                      });
                  });
              } else {
                this.countryLanguageHelper.setPrefCookie(
                  this.appConfig.get('APP_PREF_COOKIE')
                );
                this.countryLanguageHelper.setPreferedLanguages(
                  this.appConfig.get('APP_PREF_COOKIE')
                );
                if (this.propertyCheck()) {
                  this._appliSubject.next(true);
                }
              }
            },
            (err) => {
              this.countryLanguageHelper.setPrefCookie(
                this.appConfig.get('APP_PREF_COOKIE')
              );
              this.countryLanguageHelper.setPreferedLanguages(
                this.appConfig.get('APP_PREF_COOKIE')
              );
              this.opencls.next(true);
            }
          );
      } else {
        this.countryLanguageHelper.setPrefCookie(
          this.appConfig.get('APP_PREF_COOKIE')
        );
        this.countryLanguageHelper.setPreferedLanguages(
          this.appConfig.get('APP_PREF_COOKIE')
        );
      }
    } else {
      const prefCookie = this.prefCookieValue.split('=')[1];
      const countrycode =
        this.countryLanguageHelper.getCountryCodeFromPrefCookie();
      this.countryLanguageHelper.setPreferedLanguages(prefCookie);
      if (!this.disableCLS) {
        this.countryLangSvc
          .countryLanguageDataFromAPI()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe((countryLanguageData) => {
            if (countryLanguageData) {
              this.countryLanguageHelper.setData(countryLanguageData);
              if (this.propertyCheck()) {
                this._appliSubject.next(true);
              }
              if (!this.countryLanguageHelper.isDomainCorrectForPrefCookie()) {
                this.countryLanguageHelper.redirectToTranslatedSites(
                  this.countryLanguageHelper.getCountryCodeFromPrefCookie(),
                  this.countryLanguageHelper.getLanguageCodeFromPrefCookie()
                );
              }
              if (this.countryLanguageHelper.shouldShowConfirmationModal()) {
                const browserLanguage =
                  this.countryLanguageHelper.getLanguageCodeFromPrefCookie();
                const primaryLanguage =
                  this.countryLanguageHelper.getPrimaryLanguage(countrycode);
                const secondaryLanguageCode =
                  this.countryLanguageHelper.getSecondaryLanguage(countrycode);
                if (browserLanguage && primaryLanguage) {
                  if (browserLanguage !== primaryLanguage.languageCode) {
                    this.openLangSelectConfirmationModal(
                      countryCode,
                      browserLanguage,
                      primaryLanguage.languageCode
                    );
                  } else if (
                    secondaryLanguageCode &&
                    browserLanguage !== secondaryLanguageCode
                  ) {
                    this.openLangSelectConfirmationModal(
                      countryCode,
                      browserLanguage,
                      secondaryLanguageCode.languageCode
                    );
                  }
                }
              }
            }
          });
      }
    }
  }

  openLangSelectConfirmationModal(
    countrycode,
    languageCode,
    secondaryLanguageCode,
    el?,
    renderer?
  ) {
    let obj;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: false,
      keyboard: false
    };
    obj = Object.assign({}, config, {
      class: 'lang-select-confrimation-modal'
    });
    this.bsModalConfirmationRef = this.modalService.show(
      FlyoutLangSelectConfirmationComponent,
      obj
    );
    this.bsModalConfirmationRef.content.countryLanguageContent =
      this.countryLanguageContent;
    this.bsModalConfirmationRef.content.setCLSData(
      countrycode,
      languageCode,
      secondaryLanguageCode
    );
    if (
      location.pathname === '/completepurchase/trip-summary' &&
      el &&
      renderer
    )
      this.srv.dragModalContainers(el, renderer);
  }

  setAlertFlag(alertFlag) {
    this.alertflag = alertFlag;
  }

  getAlertFlag(): boolean {
    return this.alertflag;
  }

  propertyCheck() {
    this.prop = this.appConfig.get('APP_PERFORMANCE');
    if (this.prop === 'true') {
      return true;
    } else {
      return false;
    }
  }
}
